var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNarrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8345 4.23441C9.98452 4.08444 10.188 4.00018 10.4001 4.00018C10.6122 4.00018 10.8157 4.08444 10.9657 4.23441L14.1657 7.43441C14.3157 7.58443 14.3999 7.78788 14.3999 8.00001C14.3999 8.21214 14.3157 8.41559 14.1657 8.56561L10.9657 11.7656C10.8148 11.9113 10.6127 11.992 10.403 11.9902C10.1932 11.9883 9.99257 11.9042 9.84424 11.7559C9.69592 11.6075 9.61178 11.4069 9.60996 11.1971C9.60814 10.9874 9.68877 10.7853 9.8345 10.6344L11.6689 8.80001H2.4001C2.18792 8.80001 1.98444 8.71573 1.83441 8.5657C1.68438 8.41567 1.6001 8.21219 1.6001 8.00001C1.6001 7.78784 1.68438 7.58436 1.83441 7.43433C1.98444 7.2843 2.18792 7.20001 2.4001 7.20001H11.6689L9.8345 5.36561C9.68452 5.21559 9.60027 5.01214 9.60027 4.80001C9.60027 4.58788 9.68452 4.38443 9.8345 4.23441Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNarrowRight);
export default __webpack_public_path__ + "static/media/ArrowNarrowRight.4a2a229c4a8bf22c6931ce8953206f6b.svg";
export { ForwardRef as ReactComponent };